// extracted by mini-css-extract-plugin
export var divider = "_rm-0";
export var systemMessage = "_rm-1";
export var systemMessageWrapper = "_rm-2";